import { GridsterItem, GridsterItemComponentInterface } from 'angular-gridster2';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { FormFieldObj } from '../../manager/baselines/form-field.obj';
import { PivotField } from '../../manager/baselines/pivot-field.obj';

/**
 * un élément de widget, compatible avec le contrat d'interface Gridster
 * contient le gridsterItem & la conf Allkeyme
 */
export class GridsterWidgetItem implements GridsterItem {
  
  /** construction sur add depuis la vue template. Sinon, création depuis la conf json */
  public static constructFromGridster(grit: GridsterItem): GridsterWidgetItem {
    const result: GridsterWidgetItem = new GridsterWidgetItem(); 
    result.feedCoords(grit.x, grit.y, grit.rows, grit.cols);
    return result;
  }

  /** le vrai widget */
  public source: WidgetConfigurationItemObj;

  public field: FormFieldObj | PivotField; // champ d'origine sur la baseline ou que le FS
  public subField: string; // un sous-champ de type FD, avec champ de restitution # trsLabel
  public format: string; // format demandé
  public readOnly: boolean = false;
  x: number;
  y: number;
  rows: number;
  cols: number;

  /**
   * constructeur. Si existe, alimentation de la partie "Gridster" depuis le widget
   * @param wcio 
   * @param champ source (BL/ FD)
   */
  constructor(wcio?: WidgetConfigurationItemObj, field?: FormFieldObj | PivotField) {
    if (wcio != null) {
      this.source = wcio;
      this.x = wcio.x;
      this.y = wcio.y;
      this.cols = wcio.cols;
      this.rows = wcio.rows;
      this.subField = wcio.subField;
    } else {
      this.source = new WidgetConfigurationItemObj();
    }
    this.field = field;
    this.format = this.source.fmt;
    this.readOnly = !!this.source.ro;
  }

  /** alimentation des coordonnées (sur create) */
  public feedCoords( x: number, y: number, rows: number, cols: number): void {
    this.source.x = x;
    this.source.y = y;
    this.source.cols = cols;
    this.source.rows = rows;
    this.x = x;
    this.y = y;
    this.rows = rows;
    this.cols = cols;
  }

  /** alimentation des coordonnées du widget depuis les valeurs gridster (pas moyen de mettre en place getSet sur coords...) */
  public updateCoords(): void {
    this.source.x = this.x;
    this.source.y = this.y;
    this.source.cols = this.cols;
    this.source.rows = this.rows;
  }

  /** partie qui sert à rien... */
  layerIndex?: number;
  initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;
  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  compactEnabled?: boolean;
  maxItemRows?: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
  [propName: string]: any;

}
